'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('styled-components');
require('../../enums/accordion.js');
require('../../enums/alert.js');
require('../../enums/avatar.js');
require('../../enums/breakpoints.js');
require('../../enums/button.js');
require('../../enums/code-editor.js');
require('../../enums/colors.js');
require('../../enums/combobox.js');
require('../../enums/date.js');
require('../../enums/drag-and-drop.js');
require('../../enums/dialog.js');
require('../../enums/divider.js');
require('../../enums/dropdown.js');
require('../../enums/fieldset.js');
require('../../enums/font-icon.js');
require('../../enums/fonts.js');
require('../../enums/headings.js');
require('../../enums/input.js');
require('../../enums/keys.js');
require('../../enums/list.js');
require('../../enums/listbox.js');
require('../../enums/loader.js');
var margin = require('../../enums/margin.js');
require('../../enums/option.js');
require('../../enums/pill.js');
require('../../enums/placements.js');
require('../../enums/popout.js');
require('../../enums/privacy.js');
require('../../enums/radio-group.js');
require('../../enums/status.js');
require('../../enums/switch.js');
require('../../enums/table.js');
require('../../enums/tooltip.js');
require('../../enums/transitions.js');
require('../../enums/widths.js');

/**
 * Get Styled Component divider theme
 * @param options GetDividerThemeOptions
 * @returns ThemedCssFunction<DefaultTheme>
 */ const getDividerTheme = (options)=>{
    const { look  } = options;
    return styled.css`
    border-top-color: ${({ theme  })=>theme.divider[look].borderColor};
  `;
};
/**
 * Get Styled Component divider margins
 * @param options GetDividerMarginOptions
 * @returns ThemedCssFunction<DefaultMargin>
 */ const getDividerMargin = (options)=>{
    const { margin: margin$1  } = options;
    switch(margin$1){
        case margin.Margins.Large:
            {
                return styled.css`
        margin: 30px 0;
      `;
            }
        case margin.Margins.Medium:
            {
                return styled.css`
        margin: 15px 0;
      `;
            }
        case margin.Margins.None:
            {
                return styled.css`
        margin: 0;
      `;
            }
        case margin.Margins.Small:
            {
                return styled.css`
        margin: 10px 0;
      `;
            }
        default:
            {
                return styled.css``;
            }
    }
};

exports.getDividerMargin = getDividerMargin;
exports.getDividerTheme = getDividerTheme;
//# sourceMappingURL=divider.js.map
